import AdminLoginPage from './AdminLoginPage.vue';
import AdminDashboardPage from './AdminDashboardPage.vue';
import AddCustomCardPage from './AddCustomCardPage.vue';
import EditCustomCardPage from './EditCustomCardPage.vue';

export default [
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLoginPage,
    meta: { title: 'Admin Login' }
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: AdminDashboardPage,
    meta: { requiresAuth: false, title: 'Admin Dashboard' }
  },
  {
    path: '/admin/add',
    name: 'AdminAddCard',
    component: AddCustomCardPage,
    meta: { requiresAuth: false, title: 'Add Custom Card' }
  },
  {
    path: '/admin/edit/:id',
    name: 'AdminEditCard',
    component: EditCustomCardPage,
    meta: { requiresAuth: false, title: 'Edit Custom Card' }
  }
];
